import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { Action } from '../../../domain/infra/remote';
import { OtpSessionDto } from '../../../domain/otp/otp';
import { RemoteResponse } from '../../../domain/infra/remote';
import { RemoteStatus } from '../../../domain/infra/remote';
import {GhostComponent} from '../../../utils/ghostComponent';
import {RemoteInfoMedia} from '../../../domain/chargeRecord/remoteInfoChargeRecord';
import { IziviaLoggerService } from '../../../services/common/iziviaLogger.service';

@Component({
    selector: 'otp-details',
    templateUrl: './otpDetails.component.html',
    styleUrls: ['./otpDetails.component.scss'],
})
export class OtpDetailsComponent extends GhostComponent implements OnChanges {
    @Input() otpSession: OtpSessionDto;
    @Output() remoteDoneEvent: EventEmitter<RemoteResponse> = new EventEmitter();

    // dirty hack to enable type-safety to the view
    Action = Action;

    canShowRemoteStart: boolean;
    remoteStart: boolean;
    remoteRequest: RemoteInfoMedia;

    constructor(private readonly loggerService: IziviaLoggerService) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.otpSession) {
            const otpSession: OtpSessionDto = changes.otpSession.currentValue;
            this.canShowRemoteStart = !!otpSession
                && !!otpSession.remoteStart
                && !!otpSession.otpCode
                && !!otpSession.infraChargeDto
                && !!otpSession.infraChargeDto.station
                && !!otpSession.infraChargeDto.station.id
                && !!otpSession.infraChargeDto.chargePoint
                && !!otpSession.infraChargeDto.chargePoint.id
                && !!otpSession.infraChargeDto.plug
                && !!otpSession.infraChargeDto.plug.id;
        }
    }

    showRemoteStart() {
        this.remoteStart = true;
        this.remoteRequest = new RemoteInfoMedia(this.otpSession.infraChargeDto.station.id,
            this.otpSession.infraChargeDto.chargePoint.id,
            this.otpSession.infraChargeDto.plug.id,
            this.otpSession.otpCode);
        this.remoteRequest.chargeAreaRef = this.otpSession.infraChargeDto.chargeArea.id;
    }

    handleRemoteResponse(remoteResponse: RemoteResponse) {
        if (remoteResponse?.status === RemoteStatus.DONE) {
            remoteResponse.otpSessionRef = this.otpSession.id;
            this.remoteDoneEvent.emit(remoteResponse);
        } else if (remoteResponse?.status === RemoteStatus.TIMEOUT) {
            this.loggerService.debug('[handleRemoteResponse] TIMOUT', remoteResponse);
            this.remoteDoneEvent.emit(remoteResponse);
        } else {
            this.remoteRequest = null;
            this.remoteDoneEvent.emit(remoteResponse);
        }
    }

    generateGhost(): void {
    }
}
